module.exports = __webpack_public_path__ + "media/assets/images/sales-processes-user-cb02b8cda58f0beb55d55c3cec409833.svg";